import type { GatewayMethodsFetchResult } from './gatewayMethodsApi.js';

/**
 * Resolves gateway provider slot id from GetGatewayMethods response (FD-45).
 * Returns undefined when readiness is blocked.
 */
export function resolveGatewayProviderSlotId(
  gatewayMethodsResponse?: GatewayMethodsFetchResult | null
): string | undefined {
  if (gatewayMethodsResponse?.readinessBlocked === true) {
    return undefined;
  }
  const slotId = gatewayMethodsResponse?.providerSlotId.trim() ?? '';
  if (slotId.length === 0) {
    return undefined;
  }
  return slotId;
}
